import { render, staticRenderFns } from "./AngryIcon.vue?vue&type=template&id=9c77eb6a&"
import script from "./AngryIcon.vue?vue&type=script&lang=js&"
export * from "./AngryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports